
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14.427 13.759"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 7114","d":"M14.427 5.332q0-.321-.486-.4L9.589 4.3 7.638.355Q7.473 0 7.213 0t-.425.355L4.838 4.3l-4.352.633Q0 5.01 0 5.332a.661.661 0 00.217.416l3.156 3.069-.746 4.335a1.408 1.408 0 00-.017.173.511.511 0 00.091.308.315.315 0 00.273.126.736.736 0 00.347-.1l3.892-2.049 3.893 2.046a.7.7 0 00.347.1.306.306 0 00.265-.126.512.512 0 00.091-.308 1.31 1.31 0 00-.009-.173l-.746-4.335L14.2 5.748a.626.626 0 00.227-.416z","fill":"#3d9ed3"}})])
          )
        }
      }
    